import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from "react-router-dom";
import CardCheckbox from '../components/CardCheckbox';
import Header from '../components/Header';
import BG from '../assets/mountain-bg.png'
import Button from '../components/Button';
import Radiocard from '../components/Radiocard';
import Pagination from '../components/Pagination';
import commonService from '../services/commonService';
import { usePost, useGet } from "../libs/service/api";
import CustomDashboardModal from '../components/Modals/CustomDashboardModal';
import Loader from "../components/loader";
import Alert from '../components/Alert'
import cookie from "../libs/cookie/client";
import AccountCreatedModal from '../components/Modals/AccountCreatedModal';
const Questionnaire = props => {
    const { toast, snackbar } = require('tailwind-toast')
    let { type, step, id } = useParams();
    const userData = commonService.getUserData();
    const [isLoading, setIsLoading] = useState(true);
    const [isOpenCustomModal, setIsOpenCustomModal] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [activeStep, setActiveStep] = useState(1);
    const [questionData, setQuestionData] = useState([]);
    const [answerData, setAnswerData] = useState([]);
    const [currentQuesID, setCurrentQuesID] = useState(0);
    const [needsAssesmentID, setNeedsAssesmentID] = useState(cookie.getItem("needsassesmentid"));
    // const [registerError, setRegisterError] = useState("")
    const [isError, setIsError] = useState(false)
    const [accountModalVisible, setAccountModalVisible] = useState(false)
    const history = useHistory();
    // const INITIAL_STATE = {
    //     emailid: "",
    //     mobileno: "",
    //     name: "",
    //     password: ""
    // };

    const GetQuestionAnswer = () => {
        return useGet("/commonapi/questionanswers?personaid=" + id).then(res => {
            if (!res.ErrorState) {
                setPageCount(res.Data.Table[0].QuestionCount)
                setQuestionData(res.Data.Table1)
                setAnswerData(res.Data.Table2)
                setIsLoading(false)
            }
        });
    }

    const SaveAnswer = (strAns) => {
        usePost('/commonapi/saveanswer',
            [{
                key: "needsassesmentid",
                value: needsAssesmentID
            },
            {
                key: "questionid",
                value: currentQuesID
            },
            {
                key: "answeridlist",
                value: strAns
            }]
        ).then(res => {
            setCurrentQuesID(0)
        });
    }

    var arrayData = [];
    const goToNextStep = (id) => {
        if (id > 0) {
            setIsError(false)
            let LastPage = pageCount;
            if (activeStep === LastPage) {
                if (cookie.getItem("userid") > 0) {
                    history.push(`/dashboard/` + needsAssesmentID);
                }
                else {
                    setIsOpenCustomModal(true)
                    //return;
                }
            }
            // setIsDisabled(true)

            arrayData = answerData.filter(c => c.ischecked == true && c.QuestionID == id);
            var strAns = '';
            for (var i = 0; i < arrayData.length; i++) {
                strAns = strAns + '' + arrayData[i].ID + ',';
            }
            // console.log("strAns");
            // console.log(strAns);
            if (strAns.length > 0) {
                SaveAnswer(strAns)
                setActiveStep(activeStep + 1)
            } else {
                //setIsError(true).
                toast().danger('', 'Select at least one Answer').with({
                    shape: 'square',
                    duration: 2000,
                    speed: 200,
                    positionX: 'end',
                    positionY: 'top',
                    color: 'text-white bg-secondary border-secondary-dark border rounded-lg',
                    fontColor: 'white',
                    fontTone: 0
                }).show()
            }
        } else {
            //setIsError(true)
            toast().danger('', 'Select at least one Answer').with({
                shape: 'square',
                duration: 2000,
                speed: 200,
                positionX: 'end',
                positionY: 'top',
                color: 'text-white bg-secondary border-secondary-dark border rounded-lg',
                fontColor: 'white',
                fontTone: 0
            }).show()
        }
    }

    const goToBackStep = () => {
        if (activeStep != 1) {
            setActiveStep(activeStep - 1)
        }
        if (activeStep == 1) {
            history.goBack()
        }
    }

    const onCustomDashboardClick = () => {
        setIsOpenCustomModal(false)
        setAccountModalVisible(true)
    }

    const onCloseAlertPopup = () => {
        history.push(`/dashboard/` + needsAssesmentID);
    }

    const onAnswerClickradio = (item, index, array) => {
        const less = "15,000 or Less";
        const more = "More than 15,000";
        if (item.AnswerText == less) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].AnswerText == more && item.QuestionID == array[i].QuestionID && array[i].ischecked) {
                    array[i].ischecked = false;
                }
            }
        }
        for (var i = 0; i < array.length; i++) {
            if (array[i].AnswerText == less && item.AnswerText == more) {
                array[i].ischecked = false;
            } else if (array[i].AnswerText == item.AnswerText) {
                array[i].ischecked = !array[i].ischecked;
            }
        }
        setCurrentQuesID(item.QuestionID)
        setAnswerData([...array])
    }

    const onAnswerClick = (item, index, array) => {

        const temparray = array.filter(i => i.QuestionID == item.QuestionID)
        const checkname = "Not Relevant";

        if (item.AnswerText == checkname) {
            for (var i = 0; i < temparray.length; i++) {
                if (temparray[i].AnswerText !== checkname && item.QuestionID == temparray[i].QuestionID && temparray[i].ischecked) {
                    temparray[i].ischecked = false;
                }
            }
        }
        for (var i = 0; i < temparray.length; i++) {
            if (temparray[i].AnswerText == checkname && item.AnswerText !== checkname) {
                temparray[i].ischecked = false;
            } else if (temparray[i].AnswerText == item.AnswerText) {
                temparray[i].ischecked = !temparray[i].ischecked;
            }
        }
        setCurrentQuesID(item.QuestionID)
        setAnswerData([...array])
        // console.log(array);
        // console.log(answerData);
        // console.log(answerData.length);
        // console.log(item.ID);
        // console.log(item.QuestionID);
        // console.log(array.length);
        // console.log(item.AnswerText)
        // array[index].ischecked = !item.ischecked;
        // var ischeckedQues = array.filter(c => c.ischecked == true && c.QuestionID == item.QuestionID).length
        // if (ischeckedQues == 0) {
        //     setIsDisabled(true)
        // } else {
        //     setIsDisabled(false)
        // }
        // console.log(array);
        //setischeckedData([...array])
    }

    const onEditAnswersClick = () => {
        setIsOpenCustomModal(false)
    }
    // const onCallPasswordClick = () => {
    //     setIsOpenCustomModal(false)
    //     setPasswordModalVisible(true)
    // }

    const onPageClick = (item, index) => {
        setCurrentQuesID(item.ID)
        setActiveStep(index + 1)
    }

    useEffect(() => {
        setNeedsAssesmentID(cookie.getItem("needsassesmentid"))
        GetQuestionAnswer()
    }, [])

    return (
        <div style={{ backgroundImage: `url(${BG})` }} className="bg-bottom bg-cover bg-no-repeat min-h-screen flex flex-col items-center relative z-10">
            <Header rightContent={
                <div className="text-secondary font-semibold pl-6 border-l border-secondary">
                    {cookie.getItem('areaofinterest').toUpperCase()}
                </div>
            } />
            {isError && <Alert type="secondary" heading="Questionnaire" content="Select Answers" isVisible={true} />}

            {questionData && questionData.length > 0 && <Pagination count={pageCount} data={questionData} active={activeStep} onClick={(item, index) => onPageClick(item, index)} />}
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <div>
                    {activeStep &&
                        <div>
                            {questionData && questionData.length > 0 && questionData.map((item, index) => {
                                if ((index + 1) == activeStep)


                                    return <div key={index}>
                                        <h2 className="text-center font-bold text-2xl mb-3 2xl:mb-8 px-6"
                                            dangerouslySetInnerHTML={{ __html: item.Question }}>
                                            {/* {item.Question} */}
                                            {/* Start by selecting your <span className="text-primary">area of interest</span> */}
                                        </h2>
                                        <div className="flex justify-center max-w-260 2xl:max-w-332 mx-auto flex-wrap">
                                            {answerData && answerData.length > 0 && answerData.map((itemans, index, array) => {
                                                if (item.ID === itemans.QuestionID) {

                                                    return item.Type == 0 ? <CardCheckbox checked={itemans.ischecked} key={index} text={itemans.AnswerText} onClick={() => { onAnswerClick(itemans, index, array) }} />
                                                        : <Radiocard key={index} checked={itemans.ischecked} title={itemans.AnswerText} onClick={() => { onAnswerClickradio(itemans, index, array) }} padded />

                                                    // return item.Type == 0 ? <CardCheckbox  disabled={isNotRelevant} ischecked={itemans.ischecked} key={index} text={itemans.AnswerText} onClick={() => { onAnswerClick(itemans, index, array) }} /> 
                                                    // : <Radiocard  key={index} active={activeCard == itemans.AnswerText} ischecked={activeCard == itemans.AnswerText} image={itemans.AnswerText == "More > 15000" ? CityPopMore : CityPopLess} title={itemans.AnswerText} onClick={() => { onAnswerClick(itemans, index, array) }} padded />
                                                }
                                            })}
                                        </div>
                                        <div className="flex justify-center my-20">
                                            <Button onClick={() => goToBackStep()} btnStyle="secondary-outline" text="Back" />
                                            <Button onClick={() => goToNextStep(item.ID)} btnStyle="secondary" text="Next" extraClasses="ml-3" />
                                        </div>
                                    </div>
                            })
                            }
                        </div>
                    }

                </div>
            }
            <CustomDashboardModal isOpen={isOpenCustomModal} onCustomDashboardClick={onCustomDashboardClick} onEditAnswersClick={onEditAnswersClick} />
            {/* <CreatePassswordModal isOpen={passwordModalVisible} onCustomDashboardClick={onCustomDashboardClick} closeTrigger={() => setPasswordModalVisible(false)} /> */}
            {/* <CustomDashboardModal isOpen={isOpenCustomModal} onCustomDashboardClick={onCustomDashboardClick} onEditAnswersClick={onEditAnswersClick} /> */}
            <AccountCreatedModal isVisible={accountModalVisible} onCloseTrigger={() => onCloseAlertPopup()} />
        </div>
    )
}

export default Questionnaire
